import { RestrictionNameDispatcher } from "../Store/Variables";

import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { RestrictionReasonClient } from "../../../../../../Wrap/Api/Account/RestrictionReason";

export class RestrictionReasonAction {
    public static getAccountRestrictions(customerId: number): void {
        const client = new RestrictionReasonClient();
        const promise = client.get(customerId);
        promise.onSuccess((data) => {
            RestrictionNameDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
}
